/* eslint-disable react/jsx-props-no-spreading */

import PropTypes from 'prop-types';

import {
    defaultSeasonalBrandConfig,
    PostOfficeLogoCore,
    ThinkMoneyLogoPrimaryDark,
    CapitalOneLogoPrimaryDark,
    CapitalOneLogoPrimaryLight,
    useBrand,
    BrandedLogo
} from '@cof/plastic-components';

import { css, styled } from 'styled-components';
import cssSystem from '@styled-system/css';

import partners from '../../partners';

const { THINKMONEY, POSTOFFICE, ASOS, CAPITAL_ONE } = partners;

const brandConfig = {
    ...defaultSeasonalBrandConfig, // TODO: this should be replaced with the defaultBrandConfig
    [CAPITAL_ONE]: CapitalOneLogoPrimaryLight,
    [THINKMONEY]: ThinkMoneyLogoPrimaryDark,
    [POSTOFFICE]: PostOfficeLogoCore
};

const StyledBrandedLogo = styled(BrandedLogo)`
    ${({ brand }) =>
        [partners.CAPITAL_ONE, partners.ASOS].includes(brand) &&
        css`
            ${cssSystem({ width: ['8.3rem', null, '14rem'] })}
        `}
    ${({ brand }) =>
        brand === partners.LITTLEWOODS &&
        css`
            ${cssSystem({ width: ['16rem', null, '22rem'] })}
        `}
`;

brandConfig[ASOS] = brandConfig.ASOS;

const Logo = ({ variant, ...otherProps }) => {
    const brand = useBrand();

    if (variant === 'dark') {
        brandConfig[CAPITAL_ONE] = (props) => (
            <CapitalOneLogoPrimaryDark width={['8.3rem', null, '14rem']} {...props} />
        );
    }

    return (
        <StyledBrandedLogo
            data-qa-id="branded-logo"
            brandConfig={brandConfig}
            allowList={null}
            variant={variant}
            mx={['auto', null, 0]}
            brand={brand}
            {...otherProps}
        />
    );
};

Logo.propTypes = {
    variant: PropTypes.string
};

export default Logo;
